module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-right-top-stone-path-background-remnants.b061a995.png";